import produce from 'immer';
import { Reducer } from 'redux';

import { Exercise, ExercisesState, ExercisesTypes } from '../types';

const initialState: ExercisesState = {
    isLoading: false,
    exercises: [],
};

const exercisesReducer: Reducer<ExercisesState> = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case ExercisesTypes.GET_LIST_EXERCISES: {
                draft.isLoading = false;
                draft.exercises = getExercisesList(
                    state.exercises ? [...state.exercises] : [],
                    action.payload.exercises,
                );
                break;
            }
            case ExercisesTypes.REQUEST_GET_LIST_EXERCISES: {
                draft.isLoading = true;
                break;
            }
            case ExercisesTypes.SAVE_EXERCISES: {
                draft.isLoading = false;
                draft.exercises = action.payload.exercises;
                break;
            }
            case ExercisesTypes.REQUEST_SAVE_EXERCISES: {
                draft.isLoading = true;
                break;
            }
            case ExercisesTypes.SAVE_EXERCISE: {
                draft.isLoading = false;
                draft.exercises = updateExercisesList(
                    state.exercises ? [...state.exercises] : [],
                    action.payload.exercise,
                );
                break;
            }
            case ExercisesTypes.REQUEST_SAVE_EXERCISE: {
                draft.isLoading = true;
                break;
            }
            case ExercisesTypes.DELETE_EXERCISE: {
                draft.isLoading = false;
                draft.exercises = draft.exercises.filter((x) => x.id !== action.payload.id);
                break;
            }
            case ExercisesTypes.REQUEST_DELETE_EXERCISE: {
                draft.isLoading = true;
                break;
            }
            default: {
                return draft;
            }
        }
    });
};

const getExercisesList = (currentExercises: Exercise[], loadedExercises: Exercise[]) => {
    const loadedExercisesIds = loadedExercises.map((exercise) => {
        return exercise.id;
    });

    return [...currentExercises.filter((x) => !loadedExercisesIds.includes(x.id)), ...loadedExercises];
};

const updateExercisesList = (currentExercises: Exercise[], exercise: Exercise) => {
    const currentExercisesIds = currentExercises.map((item) => {
        return item.id;
    });
    const isModification = currentExercisesIds.includes(exercise.id);
    if (isModification)
        return currentExercises.map((item) => {
            return item.id !== exercise.id ? item : exercise;
        });
    return [...currentExercises, exercise];
};

export { exercisesReducer };
